'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

/**
 * The last screen before a white page.
 *
 * React rendering errors escape the normal reporting hooks, so without this a
 * crash that blanks the app reaches nobody. Deliberately plain: it runs when
 * the app is already broken, so it must not depend on providers, translations
 * or the design system, any of which could be the thing that just failed.
 */
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0b0b0d',
          color: '#e8e8ea',
          fontFamily: 'system-ui, sans-serif',
          padding: '2rem',
          textAlign: 'center',
        }}
      >
        <div style={{ maxWidth: '26rem' }}>
          <h1 style={{ fontSize: '1.125rem', margin: '0 0 0.5rem' }}>Algo se rompió</h1>
          <p style={{ fontSize: '0.875rem', lineHeight: 1.6, color: '#9a9aa2', margin: 0 }}>
            Ya nos enteramos y lo estamos revisando. Tus datos están a salvo — nada de lo que
            registraste se perdió.
          </p>
          <button
            onClick={() => window.location.assign('/dashboard')}
            style={{
              marginTop: '1.25rem',
              padding: '0.6rem 1.1rem',
              borderRadius: '0.6rem',
              border: 'none',
              background: '#5ddba0',
              color: '#0b0b0d',
              fontWeight: 600,
              fontSize: '0.875rem',
              cursor: 'pointer',
            }}
          >
            Volver al panel
          </button>
        </div>
      </body>
    </html>
  );
}
